// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37eJJ","footer":"styles_footer__9U7Sm","passCodeTooltip":"styles_passCodeTooltip__R3RHF"};